import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { setColorIdForIri } from 'src/containers/ProjectDiagram/utils/colorIds';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';

export const useUpdateColorId = (iri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (colorId: string) => {
      if (!diagram || !iri) {
        return;
      }
      commitDiagramModel(diagram, setColorIdForIri(iri, colorId));
    },
    [diagram, iri]
  );
};
